import { defineMessages } from 'react-intl';

export const scope = 'chat_dataset';

export default defineMessages({
    mongo_check: {
        id: `${scope}.mongo_check`,
        defaultMessage: 'Cannot select other dataset types when MongoDB or Ameya Extract is active.',
    },
    appflyte_check: {
        id: `${scope}.appflyte_check`,
        defaultMessage: 'Cannot select other dataset types when Appflyte is active.',
    },
    excel_check: {
        id: `${scope}.excel_check`,
        defaultMessage: 'Cannot select excel analytics when Food Recall dataset is active.',
    },
    excel_food_check: {
        id: `${scope}.excel_food_check`,
        defaultMessage: 'Cannot select this dataset while Excel or Food Recall is active.',
    },
    dataset_error: {
        id: `${scope}.dataset_error`,
        defaultMessage: 'Please select at least one dataset and try again.',
    },
});
